"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SelectOptionContainer = void 0;
var react_1 = __importDefault(require("react"));
exports.SelectOptionContainer = react_1.default.forwardRef(function (props, ref) {
    var isHighlighted = props.isHighlighted, isDisabled = props.isDisabled, elementProps = __rest(props, ["isHighlighted", "isDisabled"]);
    var classes = ["c-list__item"];
    if (isHighlighted) {
        classes.push("+highlighted");
    }
    if (isDisabled) {
        classes.push("+disabled");
    }
    return react_1.default.createElement("li", __assign({ ref: ref, className: classes.join(" ") }, elementProps));
});
//# sourceMappingURL=SelectOptionContainer.js.map